
export default {
    install: function(Vue) {
        Vue.prototype.$utils = {
            isValidLoader(input){
                return /^\s*(loader|loaders)\s*$/i.test(input)
            },
            isValidStatus(input) {
                return /^\s*(online|offline|waiting)\s*$/i.test(input)
            },
            isValidFeeder(input) {
                let feeders = Object.keys(Vue.prototype.$const.feederNames).join('|')
                let reFeeders = new RegExp(`^\\s*(${feeders})\\s*$`, 'i')
                return reFeeders.test(input)
            },
            isValidCountry(input) {
                return Vue.prototype.$const.countries[input.toLowerCase()] !== undefined
            },
            isValidAS(input) {
                return /^\s*AS\d+\s*$/i.test(input)
            },
            isValidIP(input) {
                return /^\s*(\d{1,3}\.){3}\d{1,3}\s*$/.test(input)
            },
            isValidFQDN(input) {
                return /^\s*(?=.{1,254}$)((?=[a-z0-9-]{1,63}\.)(xn--+)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}\s*$/i.test(input)
            },
            isValidMd5(input) {
                return /^\s*[a-f0-9]{32}\s*$/i.test(input)
            },
            isValidSha1(input) {
                return /^\s*[a-f0-9]{40}\s*$/i.test(input)
            },
            isValidSha256(input) {
                return /^\s*[a-f0-9]{64}\s*$/i.test(input)
            },
            isValidVersion(input) {
                return /^\s*(3\.3\.1|3\.2)\s*$/i.test(input)
            },
            isValidIndex(input){
                return /^\s*(https?:\/\/(.*)(index\.php))\s*$/i.test(input)
            },
            isValidHTTPFQDN(input) {
                return /^\s*(http(?=s?):\/\/)(?=.{1,254}$)((?=[a-z0-9-]{1,63}\.)(xn--+)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}(\/?)\s*$/i.test(input)
            },
            parseSearchQuery(search) {
                let type = undefined
                if (this.isValidLoader(search)) { type = 'loaders' }
                else if (this.isValidStatus(search)) { type = 'status' }
                else if (this.isValidFeeder(search)) { type = 'feeder' }
                else if (this.isValidAS(search)) { type = 'asn' }
                else if (this.isValidIP(search)) { type = 'ip' }
                else if (this.isValidVersion(search)) { type = 'panel_version' }
                else if (this.isValidCountry(search)) { type = 'country' }
                else if (this.isValidIndex(search)) { type = 'panel_index'}
                else if (this.isValidFQDN(search)) { type = 'FQDN'}
                else if (this.isValidHTTPFQDN(search)) { type = 'HTTPFQDN'}
                return {
                    type: type,
                    query: search
                }
            }
        }
    }
}
